import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ReactComponent as CloseIcon } from "../../../../assets/images/x.svg";

function ActivateInfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3Z"
        stroke="#148DFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5V7.5"
        stroke="#148DFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.999 16C11.861 16 11.749 16.112 11.75 16.25C11.75 16.388 11.862 16.5 12 16.5C12.138 16.5 12.25 16.388 12.25 16.25C12.25 16.112 12.138 16 11.999 16"
        stroke="#148DFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function GroupActivateModal({ open, group, onClose, onConfirm }) {
  if (!group) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
        },
      }}
      PaperProps={{
        sx: {
          width: 408,
          maxWidth: "95vw",
          borderRadius: "12px",
          border: "1px solid #D5DCE1",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          m: 2,
        },
      }}
    >
      <Box sx={{ p: "24px", position: "relative" }}>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", top: 16, right: 16, p: 0.5 }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#E6F4FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ActivateInfoIcon />
        </Box>

        <Typography
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "20px",
            mt: "24px",
            mb: 1,
          }}
        >
          Activate Group
        </Typography>

        <Typography
          sx={{
            color: "#556575",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "22px",
            mb: 3,
          }}
        >
          Are you sure you want to activate{" "}
          <Box component="span" sx={{ color: "#061522", fontWeight: 400 }}>
            &quot;{group.name}&quot;
          </Box>
          ?
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={onClose}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              color: "#405261",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              textTransform: "none",
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              background: "#148DFD",
              color: "#FFF",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              textTransform: "none",
              "&:hover": { background: "#0077CC" },
            }}
          >
            Activate
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
